export default [
  {
    path: '/categorias',
    name: 'app-admin-category',
    component: () => import('@/views/apps/categorias/category-list/CategoryList.vue'),
    meta: {
      requiresAuth: true,
      action: 'read',
      resource: 'Vendedor',
      pageTitle: 'Categorias',
      breadcrumb: [
        {
          text: 'Cadastros',
          active: true,
        },
        {
          text: 'Categorias',
          active: true,
        },
      ],
    },
  },
  {
    path: '/categorias/visualizar/:id',
    name: 'app-admin-category-view',
    action: 'read',
    resource: 'Vendedor',
    component: () => import('@/views/apps/categorias/category-view/View.vue'),
    meta: {
      requiresAuth: true,
      action: 'read',
      resource: 'Vendedor',
      pageTitle: 'Categorias',
      breadcrumb: [
        {
          text: 'Cadastros',
          active: true,
        },
        {
          text: 'Listar Categorias',
          active: false,
          to: {
            name: 'app-admin-category',
          },
        },
        {
          text: 'Categorias',
          active: true,
        },
      ],
    },
  },
]
